import Info from 'components/form/Info';
import InterviewList, { Columns, OrderValue } from 'components/Interview/List';
import ProfileNavigationHead from 'components/profileNavigation/Head';
import React, { FC, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { setOrder, setPage } from 'store/actions/mentor/interviewLists';
import { StoreState } from 'store/reducers';
import useSWR from 'swr';
import Interview from 'types/Interview';
import { Action } from 'types/typeguards/reducerActions';

export const activeColumns: Columns = {
  date: true,
  hour: true,
  status: true,
  menteeName: true,
  type: true,
  viewDetails: true,
};

type RetrievedData = {
  interviews: Interview[] | undefined;
  count: number | undefined;
  pages: number | undefined;
};

type Props = {
  page: number;
  setPage: (page: number) => void;
  order: OrderValue;
  setOrder: (order: OrderValue) => void;
};
const Interviews: FC<Props> = ({ page, setPage, order, setOrder }) => {
  const currentMentorId = useSelector((state: any) => state.auth?.user?.id || state.mentor?.id || state.mentor?.mentor?.id);
  const { data } = useSWR<RetrievedData>(
    `/interview/mentor?page=${page}&order=${order}`,
  );

  const [retrievedData, setRetrievedData] = useState<RetrievedData>({
    interviews: undefined,
    count: undefined,
    pages: undefined,
  });
  useEffect(() => {
    if (data && data.interviews) {
      const enrichedAndSorted = [...data.interviews]
        .map(interview => ({
          ...interview,
            isAuthor: String(interview.authorId) === String(currentMentorId)
        }))
        .sort((a, b) => {
          return (b.id || 0) - (a.id || 0);
        });

      setRetrievedData({
        ...data,
        interviews: enrichedAndSorted as Interview[],
      });
    }
  }, [data, currentMentorId]);

  return (
    <>
      <ProfileNavigationHead
        title="Liste d'entretiens"
        subtitle="La liste de tous vos entretiens programmés"
      />
      <Info style={{ marginBottom: '1rem' }}>
        Pensez à vérifier régulièrement vos spams pour ne rien manquer.
      </Info>
      <InterviewList
        interviews={retrievedData.interviews}
        pages={retrievedData.pages}
        {...{ activeColumns, page, setPage, order, setOrder }}
        variant="mentor"
        loading={!data}
      />
    </>
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    page: state.mentor.interviewLists.main.page,
    order: state.mentor.interviewLists.main.order,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setPage: (page: number) => dispatch(setPage('main', page)),
    setOrder: (order: OrderValue) => dispatch(setOrder('main', order)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Interviews);
